import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import InputMask from 'react-input-mask';
import { FaCheck, FaXmark } from 'react-icons/fa6';
import { DateBox } from 'devextreme-react';
import useCheckUserRole from '../../BasketPage/Hooks/useCheckUserRole.ts';
import { UserRole } from '../../../Data/UserRolesEnum.ts';

const InputAddressPanel = ({ address, handleEditAddress, handleAddEditAddress, title, handleChangeAddressType, DateToOnValueChanged, dateToRef }) => {
    const { t } = useTranslation();
    const { isUserHasAccess } = useCheckUserRole()

    return <>
        {!isUserHasAccess(UserRole.Admin) && <div className="d-flex justify-content-center align-items-center ms-3 me-3 mt-2 mb-2">
            <h5 className='error-text-color '>Tylko operator z uprawnieniami administratora może definiować adres dostawy.
                Dodany adres będzie dotyczył tylko tego konkretnego zamówienia.</h5>
        </div>}
        <div className="cont profile-details-info">
            <h3 className="checkbox-list-title">{t("name_table_header_contractor_page")}
                <span className='error-text-color'> *</span>
            </h3>
            <div className="row data-container">
                <div className="col">
                    <Form.Control name='name' placeholder='Nazwa' maxLength={30} value={address.name} onChange={handleEditAddress} autoFocus required />
                </div>
            </div>
            <h3 className="checkbox-list-title mt-4">{t("address_table_header_orders_page")}
                <span className='error-text-color'> *</span>
            </h3>
            <div className="row data-container">
                <div>
                    <Form.Control name='street' placeholder='Adres' value={address.street} onChange={handleEditAddress} required />
                </div>
            </div>
            <div className="row data-container">
                <div className="col">
                    <InputMask
                        mask="99-999"
                        value={address.zipCode}
                        onChange={handleEditAddress}
                        name='zipCode'
                    >
                        {(inputProps) => (
                            <Form.Control
                                {...inputProps}
                                placeholder="Kod pocztowy"
                            />
                        )}
                    </InputMask>
                </div>
                <div className="col">
                    <Form.Control name='city' placeholder='Miejscowość' value={address.city} onChange={handleEditAddress} required />
                </div>
            </div>
            <h3 className="checkbox-list-title mt-4">{t("contact_data")}</h3>
            <div className="row data-container">
                <div className="col-12 col-md">
                    <Form.Control name='email' placeholder='E-mail (opcjonalne)' maxLength={60} value={address.email} onChange={handleEditAddress} required />
                </div>
                <div className='col-12 col-md d-flex mt-2 mt-md'>
                    <InputMask
                        mask="+48 999 999 999"
                        id="phone"
                        type="text"
                        value={address.phone}
                        onChange={handleEditAddress}
                    >
                        {(inputProps) => (
                            <Form.Control
                                {...inputProps}
                                placeholder='Tel. kontaktowy'
                                name='phone'
                                required
                            />
                        )}
                    </InputMask>
                    <span className='error-text-color'>&nbsp;*</span>
                </div>
            </div>
            <h3 className="checkbox-list-title mt-4">Data ważności adresu</h3>
            <div className="row data-container">
                <div className="col-12 col-md">
                    <div className="term-item">
                        <span className="role-name">Czy adres ma termin ważności?</span>
                        <div className={`custom-switch ${address.isExpAddress ? "active" : ""}`} onClick={() => handleChangeAddressType()}>
                            <div className="custom-switch-circle">
                                {address.isExpAddress ? <FaCheck className='primary-accent-color-text' /> : <FaXmark />}
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-12 col-md mt-2 mt-md'>
                    <DateBox adaptivityEnabled={true} defaultValue={address.expirationDate.trim() ? address.expirationDate : ''} acceptCustomValue={false} onValueChanged={DateToOnValueChanged} ref={dateToRef} visible={address.isExpAddress} />
                </div>
            </div>
            <span>
                <span className='error-text-color'>*</span> Pole wymagane
            </span>
            <div className="row data-container mt-4">
                <div className="col-12 col-md d-grid">
                    <button className='btn-app-primary' onClick={handleAddEditAddress}>
                        {title}
                    </button>
                </div>
                <div className="col">
                </div>
            </div>
        </div>
    </>
}

export default InputAddressPanel; 